import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDrop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="drop, water, precipitation, liquid"><path d="M19.25 14.0556C19.25 18.0289 16.0041 21.25 12 21.25C7.99594 21.25 4.75 18.0289 4.75 14.0556C4.75 8.40278 12 2.75 12 2.75C12 2.75 19.25 8.40278 19.25 14.0556Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconDrop;
